import Ldap from "./Ldap";

const MLdap = ()=>{
    return (
        <>
        <Ldap idpType="MLDAP" />
        </>
    )
}

export default MLdap;